export default function StatusDot({ status = 'neutral', className = '' }) {
  const cls = ['aui-status-dot', status, className].filter(Boolean).join(' ');
  return <span className={cls} aria-hidden="true" />;
}
